import React from "react";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import { RemoveRedEyeSharp } from "@mui/icons-material";
import { CrisisAlert } from "@mui/icons-material";
import { PendingActions } from "@mui/icons-material";
import StrategyPopover from "../component3/StrategyPopover";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { Link } from "react-router-dom";

export default function HomeStrategy(){
    return <Stack
    direction="row"
    alignItems="center"
    spacing={2}
    sx={{
      zIndex: 200,
      mt: 6,
      mb: 6,
      display: "flex",
      bgcolor: "rgba(255, 215, 0, 0.02671)",
      justifyContent: "space-around",
      borderBottomRightRadius: 40,
      borderBottomLeftRadius: 40,
    }}
  >
    <StrategyPopover
      content={
        <Stack alignItems="center" className="strategy">
          <CrisisAlert sx={{ fontSize: { xs: 32, md: 64 } }} />
          <Box sx={{ fontSize: { xs: 20, md: 28 } }}>Our</Box>
          <Box sx={{ fontSize: { xs: 20, md: 28 } }}> Mission</Box>
        </Stack>
      }
      bodyText={
        <Box sx={{ maxWidth: 400, p: 2 }}>
          <Typography variant="h5" sx={{ mb: 1, color: "gold" }}>
            <CrisisAlert sx={{ fontSize: "inherit" }} />
            &nbsp;&nbsp; Our Mission Statement
          </Typography>
          <Typography variant="body1">
            “To play a leading role in the build-up of expertise for
            effective management of science, technology and innovation
            management and to actively engage in policy research, design,
            evaluation and review”
          </Typography>
        </Box>
      }
    />
    <StrategyPopover
      content={
        <Stack alignItems="center" className="strategy">
          <RemoveRedEyeSharp sx={{ fontSize: { xs: 32, md: 64 } }} />
          <Box sx={{ fontSize: { xs: 20, md: 28 } }}>Our</Box>
          <Box sx={{ fontSize: { xs: 20, md: 28 } }}>Vision</Box>
        </Stack>
      }
      bodyText={
        <Box sx={{ maxWidth: 400, p: 2 }}>
          <Typography variant="h5" sx={{ mb: 1, color: "gold" }}>
            <RemoveRedEyeSharp sx={{ fontSize: "inherit" }} />
            &nbsp;&nbsp; Our Vision Statement
          </Typography>
          <Typography variant="body1">
            “To be an internationally recognised centre of excellence in
            science, technology and innovation management for sustainable
            development.”
          </Typography>
        </Box>
      }
    />
    <StrategyPopover
      content={
        <Stack alignItems="center" className="strategy">
          <PendingActions sx={{ fontSize: { xs: 32, md: 64 } }} />
          <Box sx={{ fontSize: { xs: 20, md: 28 } }}>Our</Box>
          <Box sx={{ fontSize: { xs: 20, md: 28 } }}>Mandate</Box>
        </Stack>
      }
      bodyText={
        <Box sx={{ maxWidth: 400, p: 2 }}>
          <Typography variant="h5" sx={{ mb: 1, color: "gold" }}>
            <RemoveRedEyeSharp sx={{ fontSize: "inherit" }} />
            &nbsp;&nbsp; Our Mandate
          </Typography>
          <Typography variant="body1" sx={{ mb: 1 }}>
            “To serve as a TRAINING CENTRE for the development of high level
            manpower in the Science, Technology and Innovation (STI)
            management to all tiers of government and the private sector”
          </Typography>
          <Typography variant="body1">
            “To conduct POLICY RESEARCH, evaluation and review with a view
            to providing sound policy advice for dynamic technology-driven,
            knowledge-based development;”
          </Typography>
          <Typography variant="body1">
            <Button><Link to="/about">Read More</Link></Button>
          </Typography>
        </Box>
      }
    />
  </Stack>
}